import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import CustomerForm from 'ui-shared/FormComponents/CustomerForm'
import { Create } from 'react-admin'
import { yupResolver } from '@hookform/resolvers/yup'
import { customerVS } from 'services/validations/crm/customer'

const PmiEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <CustomerForm resolver={yupResolver(customerVS)} />
      </Create>
    </SectionWrapper>
  )
}

export default PmiEdit
